import React from 'react';

const Pagination = () => {
    return (
        <ul className="pagination">
            <li><a className="disabled page-number previous" href="#"><i className="ion-ios-arrow-thin-left"></i></a></li>
            <li><span className="page-number current">1</span></li>
            <li><a className="page-number" href="#">2</a></li>
            <li>.....</li>
            <li><a className="page-number" href="#">9</a></li>
            <li><a className="page-number next" href="#"><i className="ion-ios-arrow-thin-right"></i></a></li>
        </ul>
    );
};

export default Pagination;